import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_CANDIDATE_EVENTS = gql`
    query OnboardingCandidateEvents($candidateUuid: ID) {
        onboardingCandidateEvents(candidateUuid: $candidateUuid) {
            eventCode
            eventMessage
            additionalInfo
            timestamp
        }
    }
`;

// Pas de `pollInterval` ici : le rythme de rafraichissement est pilote par le
// composant consommateur (ChatSection), qui connait l'etat ouvert/ferme du chat.
const useOnboardingCandidateEvents = (candidateUuid) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_CANDIDATE_EVENTS, {
        variables: {
            candidateUuid,
        },
        skip: !candidateUuid,
        // Sert le cache puis refait systematiquement l'appel reseau, au montage
        // comme a chaque changement de `candidateUuid`.
        fetchPolicy: 'cache-and-network',
    });

    return {
        data: data?.onboardingCandidateEvents,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingCandidateEvents;
